import { useState, type ReactNode } from 'react';
import { DisplayNameInput, validateDisplayName } from './DisplayNameInput';
import { ErrorBanner } from './ErrorBanner';
import { useT } from '../i18n';
import '../styles/screens.css';

interface CreateRoomScreenProps {
  onCreateRoom: (displayName: string) => void;
  error: string | null;
  clearError: () => void;
  onBack: () => void;
}

export function CreateRoomScreen({
  onCreateRoom,
  error,
  clearError,
  onBack,
}: CreateRoomScreenProps): ReactNode {
  const t = useT();
  const [displayName, setDisplayName] = useState('');

  const handleCreate = () => {
    const nameError = validateDisplayName(displayName);
    if (nameError) return;
    onCreateRoom(displayName.trim());
  };

  const isNameValid = displayName.trim().length >= 2;

  return (
    <div className="screen-container">
      <h1 className="screen-title">{t('createRoom.title')}</h1>

      <div className="field-group">
        <DisplayNameInput
          value={displayName}
          onChange={(v) => {
            setDisplayName(v);
            if (error) clearError();
          }}
        />
      </div>

      <ErrorBanner message={error} onDismiss={clearError} />

      <div className="btn-row">
        <button className="btn btn--link" onClick={onBack}>
          {t('createRoom.back')}
        </button>
        <button
          className="btn btn--primary"
          onClick={handleCreate}
          disabled={!isNameValid}
        >
          {t('createRoom.createRoom')}
        </button>
      </div>
    </div>
  );
}
